import { Component, computed, inject } from '@angular/core';
import { ToastService } from '../../toast.service';
import { ToastPosition } from '@agilox/ui-common';
import { ToastMessage } from '../../models/toast-message.interface';
import { ToastComponent } from '../toast/toast.component';

@Component({
	selector: 'toast-container',
	templateUrl: './toast-container.component.html',
	imports: [ToastComponent],
})
export class ToastContainerComponent {
	toastService = inject(ToastService);

	positions: ToastPosition[] = [
		'top-left',
		'top-right',
		'top',
		'bottom-left',
		'bottom-right',
		'bottom',
		'left',
		'right',
	];

	groupedToasts = computed(() => {
		const map: Record<ToastPosition, ToastMessage[]> = {
			'top-left': [],
			'top-right': [],
			top: [],
			'bottom-left': [],
			'bottom-right': [],
			bottom: [],
			left: [],
			right: [],
		};
		for (const toast of this.toastService.toasts()) {
			const position = toast.position || 'top-right';
			map[position].push(toast);
		}
		return map;
	});

	getAnimationClass(toast: ToastMessage): string {
		if (toast.dismissing) {
			switch (toast.position) {
				case 'top-left':
				case 'top-right':
				case 'top':
					return 'animate-fade-out-up';
				case 'bottom':
				case 'bottom-right':
				case 'bottom-left':
					return 'animate-fade-out-down';
				case 'left':
					return 'animate-fade-out-left';
				case 'right':
					return 'animate-fade-out-right';
				default:
					return '';
			}
		}

		switch (toast.position) {
			case 'top':
				return 'animate-slide-down';
			case 'bottom':
				return 'animate-slide-up';
			case 'top-left':
				return 'animate-slide-down';
			case 'top-right':
				return 'animate-slide-down';
			case 'bottom-left':
				return 'animate-slide-up';
			case 'bottom-right':
				return 'animate-slide-up';
			case 'left':
				return 'animate-slide-right';
			case 'right':
				return 'animate-slide-left';
			default:
				return 'animate-slide-down';
		}
	}

	getPositionClasses(position: string) {
		const isWideScreen = window.innerWidth > 1920;

		const sideOffset = 'calc((100vw - 1920px) / 2)';

		switch (position) {
			case 'top':
				return 'top-4 left-1/2 -translate-x-1/2 items-center';
			case 'top-left':
				return isWideScreen ? `top-4 left-[${sideOffset}] items-start` : 'top-4 left-4 items-start';
			case 'top-right':
				return isWideScreen ? `top-4 right-[${sideOffset}] items-end` : 'top-4 right-4 items-end';
			case 'bottom-left':
				return isWideScreen
					? `bottom-12 md:bottom-4 left-[${sideOffset}] items-start`
					: 'bottom-12 md:bottom-4 left-4 items-start';
			case 'bottom-right':
				return isWideScreen
					? `bottom-12 md:bottom-4 right-[${sideOffset}] items-end`
					: 'bottom-12 md:bottom-4 right-4 items-end';
			case 'left':
				return isWideScreen
					? `top-1/2 left-[${sideOffset}] -translate-y-1/2 items-start`
					: 'top-1/2 left-4 -translate-y-1/2 items-start';
			case 'right':
				return isWideScreen
					? `top-1/2 right-[${sideOffset}] -translate-y-1/2 items-end`
					: 'top-1/2 right-4 -translate-y-1/2 items-end';
			case 'bottom':
				return 'bottom-12 w-full md:w-auto px-4 md:px-0 md:bottom-4 md:left-1/2 md:-translate-x-1/2 items-center';
			default:
				return '';
		}
	}
}
